import { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, message } from 'antd'
import isEmpty from 'lodash/isEmpty'
import LoadingGif from '../../components/LoadingGif'
import http from '../../utils/api'
import MandateProfileContainer from './MandateProfileContainer'

const MandateProfileModal = ({
  mandateId,
  visible,
  onCancel,
  hideActions = false,
  openDataroom = false,
  onApplyToMandate,
  onAskQuestion,
  canApplyToMandate,
  companyId = null,
  companyCategory = '',
}) => {
  const [mandate, setMandate] = useState({})
  const [loading, setLoading] = useState(false)

  const fetchMandate = useCallback(() => {
    setLoading(true)
    http
      .get(`/mandates/${mandateId}`)
      .then((response) => setMandate(response.data))
      .catch(() => message.error('Could not load mandate profile'))
      .finally(() => setLoading(false))
  }, [mandateId])

  useEffect(() => {
    fetchMandate()
  }, [fetchMandate])

  return (
    <Modal
      visible={visible}
      footer={null}
      onCancel={onCancel}
      width="900px"
      bodyStyle={{ padding: 0, minHeight: '400px' }}
    >
      <LoadingGif
        spinning={loading}
        style={{ marginTop: '200px', width: '100%' }}
      >
        {visible && !isEmpty(mandate) && (
          <MandateProfileContainer
            openDataroom={openDataroom}
            mandate={mandate.mandateItem}
            hideActions={hideActions}
            onApplyToMandate={onApplyToMandate}
            onAskQuestion={onAskQuestion}
            canApplyToMandate={canApplyToMandate}
            companyCategory={companyCategory}
            companyId={companyId}
          />
        )}
      </LoadingGif>
    </Modal>
  )
}

MandateProfileModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  mandateId: PropTypes.number,
  hideActions: PropTypes.bool,
  openDataroom: PropTypes.bool,
  onApplyToMandate: PropTypes.func,
  onAskQuestion: PropTypes.func,
  canApplyToMandate: PropTypes.bool,
}

export default MandateProfileModal
